<template>
    <div>
    <div v-if="hasOptions && productOptionsType === 'flavor'" class="flavor">
       <h6>Select {{ flavorDesignation }}</h6>
        <div class="select">
            <select class="option" v-model="flavor" @change="changeFlavor">
                <option v-for="(key) in productOptionsFlavorArray" v-bind:value="key" >{{ key }}</option>
            </select>
        </div>
    </div>
    <div v-if="hasOptions && productOptionsType === 'flavor'" class="pro-cont">
        <h6>Select {{ productDesignation }}</h6>
        <ul>
            <li v-for="(key) in productOptionsArray" v-if="productOptions[key]['productOk'] && productOptions[key]['flavor'] === flavor" ><input name="Strength" :id="key" type="radio" v-model="productId" v-bind:value="key" :disabled="productOptions[key]['productSoldOut'] == 1"><label :for="key">{{productOptions[key]['designation']}}<span v-if="productOptions[key]['productSoldOut']">SoldOut</span></label></li>
        </ul>
    </div>
    <div v-if="hasOptions && productOptionsType === 'radio'" class="pro-cont">
        <h4>Select {{ productDesignation }}</h4>
        <ul>
            <li v-for="(key) in productOptionsArray" v-if="productOptions[key]['productOk']"><input name="Strength" :id="key" type="radio" v-model="productId" v-bind:value="key" :disabled="productOptions[key]['productSoldOut'] == 1"><label :for="key">{{productOptions[key]['designation']}}<span v-if="productOptions[key]['productSoldOut']">SoldOut</span></label></li>
        </ul>
        <div style="clear:both"></div>
    </div>
    <div v-if="hasOptions && productOptionsType === 'select'" class="flavor">
<br>
               <h6 >Select Product</h6>
        <div class="select">
            <select v-model="productId" class="option">
                <option v-for="(key) in  productOptionsArray" v-if="productOptions[key]['productOk']" :value="key" :disabled="productOptions[key]['productSoldOut'] == 1">{{productOptions[key]['name']}}<span v-if="productOptions[key]['productSoldOut']"> - SoldOut</span></option>
            </select>
        </div>
    </div>
    <div class="product-add-to-cart__price-container">
        <h3 class="product-add-to-cart__price" v-if="retailOnly != 1">
            <span>Member Price: </span>
            <span class="text--orange" :data-currency-symbol-left="currencySymbolLeft" :data-currency-symbol-right="currencySymbolRight" notranslate>{{ totalPrice }}</span>
        </h3>
        <h3 class="product-add-to-cart__price" v-if="this.productRetailPriceInitial > 0">
            <span v-if="retailOnly != 1">Retail Price: </span>
            <span v-if="retailOnly == 1">Price: </span>
            <span class="text--orange" :data-currency-symbol-left="currencySymbolLeft" :data-currency-symbol-right="currencySymbolRight" notranslate>{{ totalPriceRetail }}</span>
        </h3>
        <div class="purchase-1" style="margin-right:0px;display:none">
            <span><b>BV</b></span>
            <strong notranslate>{{ totalBV }}</strong>
        </div>
        <div class="purchase-1" style="margin-right:0px;" v-if="totalSale >0">
            <span><b style="color:red">Sale Discount Total</b></span>
            <strong :data-currency-symbol-left="currencySymbolLeft" :data-currency-symbol-right="currencySymbolRight" notranslate style="color:red">{{ totalSale }}</strong>
        </div>
    </div>
    <div class="product-add-to-cart__btn-container" >
        <div v-if="productOk && !productSoldOut">
          <div id="productQuantity">
           <h4 style="display:inline-block">Quantity: </h4>
           <select v-model="quantity">
              <option v-for="(n) in maxQuantity" :value="n" :key="n" notranslate>{{n * quantityMulplier}} {{productQuantityDesc}}</option>
           </select>
            <button class="btn btn-success add-to-cart-btn" @click="addtoCart"><i class="fas fa-shopping-cart"></i> Add To Cart</button>
           <button @click="addtoAuto" v-if="userAuto">ADD TO AUTOSHIP</button>
           <button @click="goToFaq" style="background-color:#4B1F84" v-if="this.faqLink">{{ faqText }}</button>
          </div>
        </div>
        <div v-else-if="productSoldOut">
           <p class="not-available-message">Due to high product demand, this product is temporarily sold out.</p>    
        </div>
        <div v-else-if="!productOk && shippingSuspended">
           <p class="not-available-message">Due to COVID 19 - the country you selected has temporarily closed their borders to international shipments. Unfortunately, we will have to temporarily suspend shipping until the country decides to open their borders again.  Please check back weekly, as each country consistently updates their status.</p>    
        </div>
        <div v-else-if="!productOk">
           <p class="not-available-message">Sorry, this product is not currently available for customers in {{ countryName }}.</p>    
        </div>
    </div>
    </div>
</template>

<script>
	import { currencySymbols, euHempCountries } from './currencySymbols.pl'
    import { exchangeRates } from './exchangeRates.pl'
    export default {
        props: {
            productIdInitial: Number,
            productPriceInitial: Number,
            productRetailPriceInitial: Number,
            bvInitial: Number,
            maxQuantity: Number,
            productOkInitial: Boolean,
            productSoldOutInitial: Boolean,
            countryCode: String,
            countryName: String,
            shippingSuspended: Boolean,
            levelPricingJson: String,
            productOptionsJson: String,
            productOptionsType: String,
            productOptionsArrayString: String,
            productOptionsFlavorArrayString: String,
            flavorInitial: String,
            productQuantityDesc: String,
            productQuantityMultiple: Number,
            productSale: Number,
            userType: String,
            faqLink: String,
            faqText: String,
            autoshipProduct: Number,
            retailOnly: Number,
        },
        data: function () {
            return {
               quantity: '1',
               productId: this.productIdInitial,
               flavor: this.flavorInitial,
               quantityMulplier: 1
            }
        },
        methods: {
           changeFlavor (e) {
              const value = e.target.value
              console.log(this.flavor,this.productId)
              var designation = this.productOptions[this.productId]['designation']
              var setProductFlag = 0;
              for (var product in this.productOptions) {
                  if (this.productOptions[product]['flavor'] === this.flavor && 
                      this.productOptions[this.productId]['designation'] === this.productOptions[product]['designation'] && 
                      this.productOptions[product]['productOk'] && 
                      this.productOptions[product]['productSoldOut'] != 1) {
                     this.productId = product
                     setProductFlag = 1
                     break
                  }
              }
              if (!setProductFlag) {
                 for (var product in this.productOptions) {
                    if (this.productOptions[product]['flavor'] === this.flavor && 
                        this.productOptions[product]['productOk'] && 
                        this.productOptions[product]['productSoldOut'] != 1) {
                        this.productId = product
                    break
                    }
                 }   
              }
           },
           addtoCart () {
              if (this.quantity != 'QTY' && this.quantity!=0) {
                 shoppingCart.addToCart(this.productId,this.quantity).then((x) => {
                   document.getElementById("openCart").click()
                 })
              }
           },  
           addtoAuto () {
              if (this.quantity != 'QTY' && this.quantity!=0) {
                 console.log("productId",this.productId,"quantity", this.quantity);
                 openProductAutoshipModal(this.productId, this.quantity);
              }
           },   
           goToFaq () {
              if (this.faqLink) {
                 console.log(this.faqLink);
                 window.open(this.faqLink);
              }
           }   
        },
        watch: {
            productId: function (newProductID, oldProductID) {
                if (this.hasOptions) {
                    var imageID = "productImageMain" + this.productIdInitial
                    console.log("image change",newProductID,imageID);
                    document.getElementById(imageID).src= "/images/products/" + this.productOptions[newProductID]['image']
                    var thumb1ID = "productThumb1_" + this.productIdInitial
                    var thumb2ID = "productThumb2_" + this.productIdInitial
                    var thumb3ID = "productThumb3_" + this.productIdInitial
                    console.log("thumbChange",thumb1ID,this.productOptions[newProductID]['image'])
                    console.log("thumbChange",thumb2ID,this.productOptions[newProductID]['imageLabel'])
                    console.log("thumbChange",thumb3ID,this.productOptions[newProductID]['imageFacts'])
                    document.getElementById(thumb1ID).src= "/images/products/" + this.productOptions[newProductID]['image']
                    document.getElementById(thumb2ID).src= "/images/products/" + this.productOptions[newProductID]['imageLabel']
                    document.getElementById(thumb3ID).src= "/images/products/" + this.productOptions[newProductID]['imageFacts']
                    document.getElementById("productThumb1Anchor_" + this.productIdInitial).href= "javascript:updateMainProductImage('/images/products/" + this.productOptions[newProductID]['image'] + "')"
                    document.getElementById("productThumb2Anchor_" + this.productIdInitial).href= "javascript:updateMainProductImage('/images/products/" + this.productOptions[newProductID]['imageLabel'] + "')"
                    document.getElementById("productThumb3Anchor_" + this.productIdInitial).href= "javascript:updateMainProductImage('/images/products/" + this.productOptions[newProductID]['imageFacts'] + "')"
                    var thumbnails = document.querySelectorAll('.product-viewer__thumbnail'),
                    thumbnailsLength = thumbnails.length,
                    i;

                    for (i = 0; i < thumbnailsLength; i++) {
                       if (thumbnails[i].classList.contains('product-viewer__thumbnail--selected')) {
                          var selectedImage = thumbnails[i].getElementsByTagName('img')[0];

                          let imageSrc = selectedImage.src;
                          updateMainProductImage(imageSrc)

                       }
                    }
                }
            }
        },
        created: function () {
            console.log("set mulplier running")
            if (this.productQuantityMultiple > 1) {
                this.quantityMulplier = this.productQuantityMultiple
            }
        },
        computed: {
            totalPrice: function () {
              var calcQuantity = this.quantity
              console.log(this.productId,this.quantity,this.productQuantityDesc)
              if (calcQuantity == '0' || calcQuantity == 'QTY') {
                 calcQuantity = 1
              }
              if (this.levelPricing[this.productId]) {
                 var levelArray = [];
                 for (var key in this.levelPricing[this.productId]['customer']) {
                    levelArray.push(key)
                 }
                 levelArray.sort(function(a, b){return b-a})
                 var levelLength = levelArray.length;
                 var levelQuantity = calcQuantity;
                 var totalPrice = 0;
                  for(let i = 0 ; i < levelLength; i++) {
                     let val = levelArray[i];
                     console.log(val)
                     var tempCount = Math.floor(levelQuantity/val);
                     var levelAmount = tempCount * this.levelPricing[this.productId]['customer'][val];
                     totalPrice = totalPrice + levelAmount;
                     levelQuantity = levelQuantity - (tempCount * val);
                  }
                  if (exchangeRates[this.countryCode]) {
                      totalPrice = totalPrice * exchangeRates[this.countryCode]
                      if (this.countryCode == 'TW') {
                         totalPrice = Math.floor(totalPrice)
                      }
                  }
                  return Number(totalPrice).toFixed(2);
              } else {
                 var price = this.productPrice
                 var tempTotal = price * calcQuantity
                 if (exchangeRates[this.countryCode]) {
                      tempTotal = tempTotal * exchangeRates[this.countryCode]
                      if (this.countryCode == 'TW') {
                         tempTotal = Math.floor(tempTotal)
                      }
                 }
                 return Number(tempTotal).toFixed(2)
              }
            },
            totalPriceRetail: function () {
              var calcQuantity = this.quantity
              console.log(this.productId,this.quantity)
              if (calcQuantity == '0' || calcQuantity == 'QTY') {
                 calcQuantity = 1
              }
              if (this.levelPricing[this.productId]) {
                 var levelArray = [];
                 for (var key in this.levelPricing[this.productId]['retail']) {
                    levelArray.push(key)
                 }
                 levelArray.sort(function(a, b){return b-a})
                 var levelLength = levelArray.length;
                 var levelQuantity = calcQuantity;
                 var totalPrice = 0;
                  for(let i = 0 ; i < levelLength; i++) {
                     let val = levelArray[i];
                     console.log(val)
                     var tempCount = Math.floor(levelQuantity/val);
                     var levelAmount = tempCount * this.levelPricing[this.productId]['retail'][val];
                     totalPrice = totalPrice + levelAmount;
                     levelQuantity = levelQuantity - (tempCount * val);
                  }
                  if (exchangeRates[this.countryCode]) {
                      totalPrice = totalPrice * exchangeRates[this.countryCode]
                      if (this.countryCode == 'TW') {
                         totalPrice = Math.floor(totalPrice)
                      }
                  } 
                  return Number(totalPrice).toFixed(2);
              } else {
                 var price = this.productRetailPrice
                 var tempTotal = price * calcQuantity
                 if (exchangeRates[this.countryCode]) {
                      tempTotal = tempTotal * exchangeRates[this.countryCode]
                      if (this.countryCode == 'TW') {
                         tempTotal = Math.floor(tempTotal)
                      }
                 }
                 return Number(tempTotal).toFixed(2)
              }
            },
            totalSale: function () {
              var calcQuantity = this.quantity
              if (calcQuantity == '0' || calcQuantity == 'QTY') {
                 calcQuantity = 1
              }
              var sale = this.productSaleAmount
              var tempTotal = sale * calcQuantity
              if (exchangeRates[this.countryCode]) {
                   tempTotal = tempTotal * exchangeRates[this.countryCode]
                   if (this.countryCode == 'TW') {
                      tempTotal = Math.floor(tempTotal)
                   }
              }
              return Number(tempTotal).toFixed(2)
            },
            totalBV: function () {
              var calcQuantity = this.quantity
              if (calcQuantity == '0' || calcQuantity == 'QTY') {
                 calcQuantity = 1
              }
              var bv = this.bv
              var tempTotal = bv * calcQuantity
              return tempTotal
            },
            productOptionsArray: function () {
               return this.productOptionsArrayString.split(",");
            },            
            productOptionsFlavorArray: function () {
               return this.productOptionsFlavorArrayString.split(",");
            },
//            flavor: function () {
//               return this.productOptions[this.productId]['flavor']
//            },
            productOptions: function () {
				return JSON.parse(this.productOptionsJson)
			},
            hasOptions: function () {
                if (this.productOptions[this.productId]) {
                    return 1;
                }
                return 0
            },
            orderedOptions: function () {
                 return _.orderBy(this.users, 'name')
            },
            productDesignation: function () {
                if (this.hasOptions) {
                    if (this.productOptions[this.productId]['designationDesc']) {
                       return this.productOptions[this.productId]['designationDesc'];
                    }
                }
                return ''
            },
            flavorDesignation: function () {
                if (this.hasOptions) {
                    if (this.productOptions[this.productId]['flavorDesc']) {
                       return this.productOptions[this.productId]['flavorDesc'];
                    }
                }
                return ''
            },
            productOk: function () {
                if (this.hasOptions) {
                    if (this.productOptions[this.productId]['productOk']) {
                       return this.productOptions[this.productId]['productOk'];
                    }
                }
                return this.productOkInitial
            },
            productSoldOut: function () {
                if (this.hasOptions) {
                    if (this.productOptions[this.productId]['productSoldOut']) {
                        return true;
                    } else {
                        return false;
                    }
                }
                return this.productSoldOutInitial
            },
            productPrice: function () {
                if (this.hasOptions) {
                    if (this.productOptions[this.productId]['productPrice']) {
                        return this.productOptions[this.productId]['productPrice'];
                    }
                }   
                return this.productPriceInitial
            },
            productRetailPrice: function () {
                if (this.hasOptions) {
                    if (this.productOptions[this.productId]['productRetailPrice']) {
                       return this.productOptions[this.productId]['productRetailPrice'];
                    }
                }
                return this.productRetailPriceInitial
            },
            productSaleAmount: function () {
                if (this.hasOptions) {
                    if (this.productOptions[this.productId]['sale']) {
                       return this.productOptions[this.productId]['sale'];
                    } else {
                        return 0
                    }
                } else if (this.productSale) {
                    return this.productSale;
                }
                return 0
            },
            userAuto: function () {
                if (this.autoshipProduct && (this.userType == 'C' || this.userType == 'D') && this.bvInitial>0 ) {
                   return true
                }
                return false
            },
            bv: function () {
                if (this.hasOptions) {
                   if (this.productOptions[this.productId]['bv']) {
                       return this.productOptions[this.productId]['bv'];
                   }    
                }
                return this.bvInitial
            },
            levelPricing: function () {
				return JSON.parse(this.levelPricingJson)
			},
            currencySymbolLeft: function () {
                if (!euHempCountries[this.countryCode] && !currencySymbols.left[this.countryCode] && !currencySymbols.right[this.countryCode]) {
                    return currencySymbols.left.US
                } else {
                    return currencySymbols.left[this.countryCode]
                }
            },
            currencySymbolRight: function () {
                if (euHempCountries[this.countryCode] && this.countryCode != 'GB') {
                    return currencySymbols.right.EU
                } else {
                    return currencySymbols.right[this.countryCode]
                } 
            }
        }
    }

</script>
